import React, { useEffect, useMemo, useState } from "react";
import styles from '../styles/messageRender.module.scss'
import { useMessageContext } from "../context";
import AnnouncementList from "./announcementList";
import MessageList from "./messageList";

const MessageRender = () => {
  const { selectedItem } = useMessageContext();

  /**
   * 根据 selectedItem?.msgType 渲染对应组件
   * 3为公告列表   其他为站内信消息列表
   */
  
  switch (selectedItem?.msgType) {
    case 3:
      return <AnnouncementList />;
    default:
      return <MessageList />;
  }
  
}

export default MessageRender